import type { Shadows, ThemeOptions } from '@mui/material';
import type { Tokens } from '@zeus/themes';

export function createShadows(tokens: Tokens): ThemeOptions['shadows'] {
  const shadows = [
    'none',
    tokens.shadows['1'],
    tokens.shadows['2'],
    tokens.shadows['3'],
    tokens.shadows['4'],
    tokens.shadows['5'],
    tokens.shadows['6'],
    tokens.shadows['7'],
    tokens.shadows['8'],
    tokens.shadows['9'],
    tokens.shadows['10'],
    tokens.shadows['11'],
    tokens.shadows['12'],
    tokens.shadows['13'],
    tokens.shadows['14'],
    tokens.shadows['15'],
    tokens.shadows['16'],
    tokens.shadows['17'],
    tokens.shadows['18'],
    tokens.shadows['19'],
    tokens.shadows['20'],
    tokens.shadows['21'],
    tokens.shadows['22'],
    tokens.shadows['23'],
    tokens.shadows['24'],
  ] satisfies Shadows;

  return shadows;
}
